import React from 'react';
import styled from 'styled-components';

const Footer = () => {
  return (
    <FooterContainer>
      <h5>
        &copy; {new Date().getFullYear()}
        <span> Mulla/Tree4Earth </span>
      </h5>
      <h5>All rights reserved</h5>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  width: 100%;
  height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--clr-black);
  text-align: center;
  background: var(--primaryFooterColor);
  h5 {
    color: var(--mainWhite);
    margin: 0.1rem;
    font-weight: 400;
    text-transform: none;
    line-height: 1.25;
  }
  bottom: 0;
`;

export default Footer;
